<div class="modal-header">
  <h4 class="modal-title">Rehome {{ petName }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()">
  </button>
</div>
<div class="modal-body">
  <p>
    If you wish to rehome your pet please contact us on <strong>{{ companyPhoneNumber }}</strong> and one of our friendly customer service will guide you
    through the process.
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success text-white" ngbAutofocus (click)="activeModal.dismiss()">
    Got it
  </button>
</div>
